import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useNavigate,
  useLocation,
  useParams,
} from 'react-router-dom';
import i18n from 'i18next';
import './App.css';

// На ask.lovestoria.org build содержит ТОЛЬКО лендинг — все public/private
// маршруты (login/dashboard/cover/photos/checkout/terms) сюда не вкомпиливаем.
import Landing from './pages/Landing';

import {
  SUPPORTED_CODES,
  STORAGE_KEY,
} from './i18n/languages';
import { detectLanguageByIp } from './i18n/detectByIp';

/**
 * Lang scope для лендинга: /<lang>. Валидирует :lang против SUPPORTED_CODES,
 * синхронит i18n + localStorage. Неизвестный сегмент трактуется как путь
 * (legacy /ru/login и т.п.) и сбрасывается на корень.
 */
function LangScope() {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!lang) return;
    if (!SUPPORTED_CODES.includes(lang)) {
      navigate('/', { replace: true });
      return;
    }
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      /* localStorage unavailable */
    }
  }, [lang, navigate, location.pathname]);

  return <Outlet />;
}

/**
 * Корень '/': язык = URL > localStorage > IP > fallback. Редиректит на /<lang>/.
 */
function RootRedirect() {
  const navigate = useNavigate();
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      let lang = '';
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored && SUPPORTED_CODES.includes(stored)) lang = stored;
      } catch {
        /* ignore */
      }
      if (!lang) {
        lang = await detectLanguageByIp();
      }
      if (cancelled) return;
      navigate('/' + lang, { replace: true });
      setDecided(true);
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return decided ? null : null;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      <Route path="/:lang" element={<LangScope />}>
        <Route index element={<Landing />} />
      </Route>

      {/* Любой другой URL → корень → лендинг. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
